module.exports = __webpack_public_path__ + "img/SKMJ_alert.08af55de.png";